// import Arrow from "@/components/Default/CarouselSlick/v1/Arrow"
import Arrow from "./Arrow"

export const doubleFeatureContentCardSettings = {
  dots: false,
  infinite: true,
  fade: true,
  autoplay: false,
  cssEase: "ease-in-out",
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false,
}

export const singleSliderSettings = (
  cb,
  topPosition,
  autoplay,
  autoplaySpeed,
  options = {}
) => {
  const isOptionsOnlyCall =
    typeof cb === "object" && cb !== null && topPosition === undefined
  const resolvedCb = isOptionsOnlyCall ? undefined : cb
  const resolvedTopPosition = isOptionsOnlyCall ? undefined : topPosition
  const resolvedAutoplay = isOptionsOnlyCall ? undefined : autoplay
  const resolvedAutoplaySpeed = isOptionsOnlyCall ? undefined : autoplaySpeed
  const {
    addAnalyticsForArrows,
    afterChangeCb = () => {},
    showArrowIndication = true,
  } = isOptionsOnlyCall ? cb : options

  return {
    autoplay: resolvedAutoplay,
    autoplaySpeed: resolvedAutoplaySpeed,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    arrows: showArrowIndication,
    infinite: true,
    centerMode: false,
    beforeChange: (_, current) =>
      typeof resolvedCb === "function"
        ? resolvedCb(current + 1, current)
        : undefined,
    afterChange: (a, b) =>
      typeof afterChangeCb === "function" ? afterChangeCb(a, b) : undefined,
    nextArrow: (
      <Arrow
        label="Next"
        topPosition={resolvedTopPosition}
        addAnalyticsForArrows={addAnalyticsForArrows}
      />
    ),
    prevArrow: (
      <Arrow
        label="Previous"
        topPosition={resolvedTopPosition}
        addAnalyticsForArrows={addAnalyticsForArrows}
      />
    ),
  }
}
